import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "relative"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'Progress',
  props: {
    value: null,
    colors: {
      default: () => [[33, 'error'], [66, 'warning'], [100, 'success']]
    },
    color: null,
    showValue: {
      type: Boolean
    },
    reverse: {
      type: Boolean
    },
    unit: null
  },
  setup(__props) {
    const props = __props;
    const status = computed(() => {
      if (props.color) {
        return 'default';
      }
      const [limit, status] = props.colors.find(([limit, color]) => limit >= props.value);
      return status;
    });
    return (_ctx, _cache) => {
      const _component_NProgress = _resolveComponent("NProgress");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NProgress, {
        type: "line",
        percentage: __props.value,
        "show-indicator": __props.showValue,
        status: _unref(status),
        color: __props.color ? _ctx.ColorValue[__props.color][500] : null,
        class: _normalizeClass({
          'n-progress--reverse': __props.reverse
        })
      }, {
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "value", _normalizeProps(_guardReactiveProps({
          value: __props.value
        })), () => [_createTextVNode(_toDisplayString(Math.round(__props.value)) + _toDisplayString(__props.unit), 1)])]),
        _: 3
      }, 8, ["percentage", "show-indicator", "status", "color", "class"]), _renderSlot(_ctx.$slots, "default")]);
    };
  }
});